/**
 * libsodium (WASM) backend, initialised once at module load.
 *
 * `libsodium-wrappers` requires awaiting `sodium.ready` before any primitive is
 * called. We do that with a top-level `await` here (valid under NodeNext ESM +
 * ES2022), so importing this module — or anything that re-exports it — resolves
 * only after libsodium is fully initialised. Every downstream crypto function
 * is therefore free to call `sodium.*` synchronously.
 *
 * We load the package via `createRequire` (its CommonJS build) rather than a
 * static ESM import: the 0.7.x ESM bundle ships a broken internal reference
 * (`modules-esm/libsodium.mjs` is missing), whereas the CJS build is correct.
 *
 * Rationale for the WASM backend: the native `sodium-native` prebuild produced
 * incorrect X25519/Ed25519 KAT results on this platform (Apple Silicon), so we
 * use the reviewed WASM build of the same libsodium. This is the fallback the
 * S0 spec explicitly permits; the public API stays synchronous and byte-only.
 *
 * We use the `-sumo` build (same reviewed libsodium, full API surface) because
 * S1 needs `crypto_hash_sha256`, which the stripped default wrapper omits. The
 * sumo build is a strict superset, so every S0 primitive behaves identically.
 */
import { createRequire } from 'node:module';
const require = createRequire(import.meta.url);
const _sodium = require('libsodium-wrappers-sumo');
await _sodium.ready;
export const sodium = _sodium;
//# sourceMappingURL=backend.js.map